import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
} from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { OpportunitySnapshotsService } from '../services/opportunity-snapshots.service';
import { Payment } from '../models/payment.model';
import { BankAccount } from '../models/bank-account.model';
import { StripeService } from '../services/stripe.service';
import { StripeElementsDirective, StripeFactoryService, StripePaymentElementComponent, StripeCardComponent } from 'ngx-stripe';
import { ConfigService } from '../services/config.service';
import { StripeCardElementOptions, StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';
import { BankAccountsService } from '../services/bank-accounts.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { PaymentsService } from '../services/payments.service';
import { SurplusLinesPlanDesign } from '../models/surplus-lines-plan-design.model';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  errorOverride: boolean = false;
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    var isSubmitted = form && form.submitted;
    if (this.errorOverride) {
      isSubmitted = true;
    }
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-payment',
  standalone: false,
  templateUrl: './payment.component.html',
  styleUrl: '../../assets/css/HighLimits.css'
})
export class PaymentComponent implements OnInit {
  @ViewChild(StripePaymentElementComponent)
  paymentElement!: StripePaymentElementComponent;
  @ViewChild(StripeCardComponent)
  card!: StripeCardComponent;
  @ViewChild(StripeElementsDirective)
  elements!: StripeElementsDirective;


  elementsOptions: StripeElementsOptions = {
    locale: 'en',
    paymentMethodCreation: 'manual',
  };

  paymentOptions: StripePaymentElementOptions = {
    paymentMethodOrder: ['card'],
    layout: {
      type: 'tabs',
      visibleAccordionItemsCount: 2
    },
  };

  cardOptions: StripeCardElementOptions = {

  };

  schedules: { DueDate: number; Amount: number; }[] = [
  ];
  paymentPlan: string = 'Year 1 Payment Schedule';
  matcher1: MyErrorStateMatcher = new MyErrorStateMatcher();
  matcher2: MyErrorStateMatcher = new MyErrorStateMatcher();
  matcher3: MyErrorStateMatcher = new MyErrorStateMatcher();
  price: number = 6600;
  premium: number = 12340;
  surplusLinesTax: number = 120.54;
  fireMarshallTax: number = 162.40;
  administrativeFee: number = 250;
  total: number = 0;
  makePayment: boolean = false;
  paymentType: string = 'R';
  accountType: string = 'checking';
  accountNumber: string = '';
  routingNumber: string = '';
  cardholderName: string = '';
  ccMonth: string = '';
  ccYear: string = '';
  cvc: string = '';
  zipCode: string = '';
  percent = 75;
  otherFees: number = 0;
  SLFees: number = 0;
  SLTaxes: number = 0;
  payment: Payment = new Payment();
  bankAccount: BankAccount | undefined;
  processingFeePercentage: number = 0;
  creditCards: any[] = [];
  SLTaxesText: string = 'Taxes';
  stripe: any;
  config: any;
  stripeClientSecret: any;
  ccElement: any;
  paymentVisible: boolean = false;
  signVisible: boolean = false;

  private _paymentFrequency: number = 12;

  public get paymentFrequency(): number {
    return this._paymentFrequency;
  }

  public set paymentFrequency(value: number) {
    this._paymentFrequency = value;
  }

  snackBarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000
  };

  readonly dialog = inject(MatDialog);

  constructor(private _snackbar: MatSnackBar,
    private _router: Router,
    private _oss: OpportunitySnapshotsService,
    private _stripeService: StripeService,
    private _configService: ConfigService,
    private _stripeFactoryService: StripeFactoryService,
    private _paymentService: PaymentsService) {
    this.config = this._configService.CurrentConfig;
  }


  ngOnInit() {
    
    if(this._oss.currentQuote.length > 0){
      this.premium = this._oss.currentQuote[0].AnnualPremium as number;
      this.otherFees = this._oss.currentQuote[0].OtherFees as number;
      this.SLFees = this._oss.currentQuote[0].SLFees as number;
      this.SLTaxesText = this._oss.currentQuote[0].SLTaxesLabel as string;
      this.SLTaxes = this._oss.currentQuote[0].SLTaxes as number;
      this.total = this._oss.currentQuote[0].YearOneCost as number;
    }


    this._stripeService.getCreditCards().subscribe(cards => {
      this.creditCards = cards;
    });

    this._stripeService.getSetupIntent().subscribe(intent => {
      this.stripeClientSecret = intent.client_secret;
      this.elementsOptions.clientSecret = this.stripeClientSecret;
    });

    this.stripe = this._stripeFactoryService.create(this.config.CreditCardVendorApiKey);

    this.routingNumber = this._oss.currentOpportunitySnapshot.PaymentRoutingNum || '';
    this.accountNumber = this._oss.currentOpportunitySnapshot.PaymentAccountNum || '';
    this.accountType = this._oss.currentOpportunitySnapshot.PaymentAccountType || 'checking';
    this.paymentType = this._oss.currentOpportunitySnapshot.PaymentMethod || 'R';

    var firstPayment = true;
    this.schedules.forEach((schedule) => {
      if (firstPayment === true) {
        schedule.Amount = this.total * .4;
        firstPayment = false;
      } else {
        schedule.Amount = (this.total - (this.total * .4)) / 3;
      }

      if (this.schedules.length > 0 && this.paymentFrequency == 13) {
        const firstQuarterAmount = this.schedules[0].Amount;
        this._paymentService.setQuarterlyPayment(firstQuarterAmount);
      }
      else{
        this._paymentService.clearQuarterlyPayment();
      }
    });

    this.paymentVisible = this._oss.currentOpportunitySnapshot.Questions.some(q => {
            const requiresAnswer = q.AnswerType == 'None'
            const hasNoBoolean = q.AnswerBoolean == null;
            const hasNoText = q.AnswerText == null || q.AnswerText.toString().trim() === '';

            return requiresAnswer || ( hasNoBoolean || hasNoText );
          });

    this.signVisible = (this._oss.currentOpportunitySnapshot.PaymentAccountNum || this._oss.currentOpportunitySnapshot.CreditCardPaymentMethodId) ? true : false;
  }

  ngAfterViewInit() {
    var currentQuote = new SurplusLinesPlanDesign;
    if (this._oss.currentQuote.length > 0) {
        currentQuote = this._oss.currentQuote[0] as SurplusLinesPlanDesign;
    }
       this._paymentService.getPaymentPlan(this._oss.currentOpportunitySnapshot.OpportunityId).subscribe((response: any) => {
        this.premium = response.Premium || currentQuote.AnnualPremium as number;
        this.SLTaxesText = currentQuote.SLTaxesLabel as string;
        this.otherFees = (Number(response.AgencyFee) + Number(response.UWFee) + Number(response.MunicipalFee) + Number(response.ServiceCharge) + Number(response.StampingFee)) || currentQuote.OtherFees as number;
        this.SLTaxes = response.Taxes ||currentQuote.SLTaxes as number;
        this.SLFees = currentQuote.SLFees as number || 0;
        this.total = Number(response.TotalCost) || currentQuote.YearOneCost as number;

        this.paymentFrequency = Number(response.PaymentPlanId) || this.paymentFrequency;
        if (response.Details) {
          this.schedules = response.Details.map((detail: any) => {
            return {
              DueDate: detail.DueDate,
              Amount: detail.Amount
            };
          });
        }
        if (this.schedules.length > 0 && this.paymentFrequency == 13) {
          const firstQuarterAmount = this.schedules[0].Amount;
          this._paymentService.setQuarterlyPayment(firstQuarterAmount);
        }
        else{
          this._paymentService.clearQuarterlyPayment();
        }
        this.paymentPlan = response.PaymentPlanName;
      });
  }

  getQuarterly() {
    this._paymentService.choosePaymentPlan(this._oss.currentOpportunitySnapshot.OpportunityId, this.paymentFrequency).subscribe(() => {
      this._paymentService.getPaymentPlan(this._oss.currentOpportunitySnapshot.OpportunityId).subscribe((response: any) => {
        this.paymentFrequency = Number(response.PaymentPlanId) || this.paymentFrequency;

        if (response.Details) {
          this.schedules = [];
          response.Details.forEach((detail: any) => (this.schedules.push({
              DueDate: detail.DueDate,
              Amount: detail.Amount
            })
          ));
        }

        this.paymentPlan = response.PaymentPlanName;

        if (this.schedules.length > 0 && this.paymentFrequency == 13) {
          const firstQuarterAmount = this.schedules[0].Amount;
          this._paymentService.setQuarterlyPayment(firstQuarterAmount);
        }
        else{
          this._paymentService.clearQuarterlyPayment();
        }
      });
    });
  }

  get selectedCreditCard(): any {
    return this.payment.SelectedPaymentMethod == 'cc' && this.creditCards && this.creditCards.find(c => c.id == this.payment.CreditCardPaymentMethodId) || null;
  }

  getTypeCode(type: string): string {
    return type[0].toUpperCase();
  }

  continue() {
    this.makePayment = true;
  }

  back() {
    this.makePayment = false;
  }

  reviewCC() {
    this.confirmCreditCard();
  }

  reviewEFT() {
    var returnOut = false;
    if (this.accountNumber.length < 8) {
      this.matcher1.errorOverride = true;
      returnOut = true;
    }
    if (this.routingNumber.length < 9) {
      this.matcher2.errorOverride = true;
      returnOut = true;
    }
    if(returnOut) {
      return;
    }
    this.confirmBankAccount();
  }

  reviewEnabled() {
    if (this.paymentType === 'ach') {
      return this.accountNumber.length >= 8 && this.routingNumber.length >= 9;
    } else {
      return this.cardholderName != '' && this.ccMonth.length >= 2 && this.ccYear.length >= 2 && this.cvc.length === 3 && this.zipCode.length === 5;
    }
  }

  confirmBankAccount() {
    const bankAccount: BankAccount = new BankAccount();
    bankAccount.AccountNum = this.accountNumber;
    bankAccount.RoutingNum = this.routingNumber;
    bankAccount.Type = this.accountType;
    localStorage.setItem('BankAccount', JSON.stringify(bankAccount));

    const updatedSnapshot = this._oss.currentOpportunitySnapshot;
    updatedSnapshot.PaymentRoutingNum = this.routingNumber;
    updatedSnapshot.PaymentAccountNum = this.accountNumber;
    updatedSnapshot.PaymentAccountType = this.accountType;
    updatedSnapshot.PaymentMethod = 'R';
    updatedSnapshot.PaymentPlanId = this.paymentFrequency;
    updatedSnapshot.PaymentAccountNickname = "Payment for opportunity: "+ this._oss.currentOpportunitySnapshot.OpportunityId;
    this._oss.update(updatedSnapshot);

    this._paymentService.choosePaymentPlan(updatedSnapshot.OpportunityId, this.paymentFrequency).subscribe(() => {
      this._paymentService.getPaymentPlan(updatedSnapshot.OpportunityId).subscribe((response: any) => {
        if (response.Details) {
          this.schedules = response.Details.forEach((detail: any) => ({
            DueDate: detail.DueDate,
            Amount: detail.Amount
          }));

          if (response.PaymentPlanId === 13 && this.schedules.length > 0) {
            const firstQuarterAmount = this.schedules[0].Amount;
            this._paymentService.setQuarterlyPayment(firstQuarterAmount);
          }
        }

        this.gotoSign();
        this._snackbar.open('Payment saved', 'Close', this.snackBarConfig);
      });
    });
  }

  confirmCreditCard() {
    const cardholderName = this.cardholderName;
    const scope = this;

    this.paymentElement.elements.submit().then((result: any) => {
      this.stripe.createPaymentMethod({
        elements: this.paymentElement.elements,
        params: {
          billing_details: { name: cardholderName }
        }
      }).subscribe((payment: any) => {
        localStorage.setItem('CreditCard', JSON.stringify(payment));

        const updatedSnapshot = this._oss.currentOpportunitySnapshot;
        updatedSnapshot.CreditCardPaymentMethodId = payment.paymentMethod.id;
        updatedSnapshot.PaymentMethod = 'R';
        updatedSnapshot.PaymentAccountNickname = "Payment Credit: " + this._oss.currentOpportunitySnapshot.OpportunityId;
        updatedSnapshot.PaymentPlanId = this.paymentFrequency;
        this._oss.update(updatedSnapshot);

        this._paymentService.choosePaymentPlan(updatedSnapshot.OpportunityId, this.paymentFrequency).subscribe(() => {
        this._paymentService.getPaymentPlan(updatedSnapshot.OpportunityId).subscribe((response: any) => {
            if (response.Details) {
              this.schedules = response.Details.map((detail: any) => ({
                DueDate: detail.DueDate,
                Amount: detail.Amount
              }));

              if (response.PaymentPlanId === 13 && this.schedules.length > 0) {
                const firstQuarterAmount = this.schedules[0].Amount;
                this._paymentService.setQuarterlyPayment(firstQuarterAmount);
              }
            }

            this.stripe.confirmCardSetup(this.stripeClientSecret, {
              payment_method: payment.paymentMethod.id
            }, {
              payment_method: {
                billing_details: {
                  name: `${this._oss.currentApplicant.FirstName} ${this._oss.currentApplicant.LastName}`
                }
              }
            }).subscribe((endresult: any) => {
              scope._snackbar.open("Your credit card information has been saved.", 'close', scope.snackBarConfig);
              scope.getCreditCards();
              
              this.gotoSign();

              if (result.error) {
                scope._snackbar.open(result.error.message, "close", scope.snackBarConfig);
              } else if (result.setupIntent) {
                scope._snackbar.open("Your credit card information has been saved.", 'close', scope.snackBarConfig);
                scope.getCreditCards();
              }
            });
          });
        });
      });
    });
  }

  getCreditCards() {
    this._stripeService.getCreditCards().subscribe(creditCards => {
      this.creditCards = creditCards;
    });
  }

  private parseCurrency(amount: string) {
    if (!amount) {
      return 0;
    }
    return parseFloat(amount.replace(/\,/g, ''));
  }

  gotoPay() {
    this._router.navigate(['/payment']);
  }

  gotoSign() {
    this._router.navigate(['/sign']);
  }

  gotoQuestionnaire() {
    this._router.navigate(['/questionnaire']);
  }

  gotoQuote() {
    this._router.navigate(['/quote']);
  }
}